import { render, staticRenderFns } from "./IconPoiGolf.vue?vue&type=template&id=1496e960&"
import script from "./IconPoiGolf.vue?vue&type=script&lang=js&"
export * from "./IconPoiGolf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports